const pallet = {
  gray5: '#F5F5F5',
  gray10: '#E9E9E8',
  gray15: '#DBDBDA',
  gray25: '#C7C6C5',
  gray50: '#878683',
  gray60: '#5F5D59',
  gray80: '#4B4945',
  gray90: '#373530',

  lightBlue: '#E6E7F2',
  white: '#FFF',
  blue: '#5D6DD9',
  indexRed: '#FED7D7',

  // yellows (low number is light)
  yellow10: '#FFF9C9', // note yellows
  yellow20: '#FFF399',
  yellow30: '#FFEC66',

  yellow60: '#FFF192', // quote yellows
  yellow70: '#FFEA61',
  yellow80: '#FFD400',
};

export const colors = {
  text: {
    primary: pallet.gray90,
    header: pallet.gray90,
    placeholder: pallet.gray50,
    subtitle: pallet.gray50,
    description: pallet.gray80,
    button: pallet.gray60,
    link: pallet.blue,
    error: pallet.indexRed,
  },

  button: {
    accept: { primary: '#C6F6B9', hover: '#B0E0A2' },
    reject: { primary: pallet.indexRed, hover: '#E8C1C0' },
    hover: pallet.gray10,
    selected: pallet.gray15,
  },

  bg: {
    primary: pallet.white,
    surface: pallet.gray5,
    hover: pallet.gray5,
    selected: pallet.gray10,
    dragging: pallet.gray10,
    dropzone: pallet.lightBlue,
    suggestion: { primary: '#F4FDF1', hover: '#E9F9E0' }, // light green for new note suggestions
    suggestionDelete: { primary: '#FFF0F0', hover: '#FFE0E0' }, // light red for deletion suggestions
    library: '#fafafa',
    // Annote backgrouns (note and quote)
    note: {
      primary: `var(--highlight-note-color, ${pallet.yellow10})`,
      hover: pallet.yellow20,
      focus: 'rgb(255, 212, 0, .6)', // pallet.yellow30,
    },
    quote: {
      primary: `var(--highlight-default-color, ${pallet.yellow60})`,
      hover: pallet.yellow70,
      focus: pallet.yellow80,
    },
  },

  lines: {
    indexRed: pallet.indexRed,
    link: pallet.gray15,
    selected: pallet.blue,
    flowLink: pallet.gray50,
  },

  icon: {
    primary: pallet.gray80,
    placeholder: pallet.gray50,
    hover: pallet.gray90,
    active: pallet.gray60,
  },

  borders: {
    input: {
      primary: pallet.gray10,
      selected: pallet.gray25,
    },
  },

  shadow: {
    toolbar: '0px 1px 2px 0px rgba(15, 15, 15, 0.16), 0px 0px 1px 0px rgba(0, 0, 0, 0.12)',
    toolbar_button: '0 1px 2px 0px rgba(15, 15, 15, 0.16), 0 0px 0px 0px rgba(0, 0, 0, 0.12)',
    button: '1px 1px 2px -1px rgba(15, 15, 15, 0.16), 1px 0px 1px -1px rgba(0, 0, 0, 0.12)',
    surfacenav: '0px 0px 1px 0px rgba(0, 0, 0, 0.12), 0px 1px 2px 0px rgba(15, 15, 15, 0.16)',
    active: '0px 1px 1px 0px rgba(15, 15, 15, 0.08)',
    card: {
      default: '0px 1px 2px rgba(15, 15, 15, 0.1)',
      hover: '0px 9px 24px rgba(15, 15, 15, 0.2), 0px 3px 6px rgba(15, 15, 15, 0.1)',
    },
  },
};
